<div [ngClass]='simple ?  "tabs-container--simple" : "tabs-container"'>
  <div [ngClass]='{ centered: centered, "tabs-container__wrapper": true }'>
    <ul role='tablist'>
      <li *ngFor='let item of panels; let i = index'>
        <a
          (click)='onNavigate(item, $event)'
          href='#'
          [ngClass]='{ active: selected === item }'
          role='tab'>
          {{ item.name }}
          <ng-container *ngIf='item.showCloseBtn'>
            <a
              (click)='close($event, item)'
              href='#'
              [ngClass]='{ "tabs_close": true, disabled: item.closeBtnDisabled }'
              role='button'
              aria-pressed='true'
              [attr.area-disabled]='item.closeBtnDisabled'
              [title]='item.closeBtnDisabled ? "" : item.closeBtnTitle'>
              <i class='fa fa-trash'></i>
              <span class='sr-only'>{{ item.closeBtnTitle }}</span>
            </a>
          </ng-container>
        </a>
      </li>
      <li class='add-btn-container' *ngIf='showAddButton'>
        <button
          (click)='addNew($event)'
          type='button'
          class='btn btn-secondary icon-btn add'
          [title]='addBtnTitle'>
          <i class='fa fa-plus-square'></i>
        </button>
      </li>
    </ul>
  </div>
  <br>
  <ng-content></ng-content>
</div>
